import {
  STATUS_BADGE_COLOR,
  STATUS_BADGE_VARIANT,
  STATUS_LABEL,
  STATUS_TONE,
  STATUS_TOOLTIP,
} from '@/api/investing/status-presentation';
import type { DerivedInvestorStatus } from '@/api/investing/types';
import { Badge, Tooltip } from '@/design-system';

export const StatusBadge = ({ status }: { status: DerivedInvestorStatus | null }) => {
  if (!status) return null;

  return (
    <Tooltip title={STATUS_TOOLTIP[status]}>
      <span>
        <Badge
          label={STATUS_LABEL[status]}
          color={STATUS_BADGE_COLOR[status]}
          variant={STATUS_BADGE_VARIANT[STATUS_TONE[status]]}
        />
      </span>
    </Tooltip>
  );
};
